import { Component } from '@angular/core';
import * as IMAGES from '../../assets/login-assets.json';

@Component({
    selector: 'app-custom-order-processing',
    templateUrl: './custom-order-processing.component.html',
    styleUrls: ['./custom-order-processing.component.scss'],
    standalone: false
})
export class CustomOrderProcessingComponent {
  images: any = (IMAGES as any).default;
}
